if (!customElements.get('reviews-showcase')) {
  class ReviewsShowcase extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);

      if (this.dataset.enableSlider !== 'true') return;
      if (!window.FoxTheme || !FoxTheme.Carousel || !FoxTheme.Swiper) return;

      this.initSlider();
    }

    disconnectedCallback() {
      if (this.sliderInstance && this.sliderInstance.slider) {
        this.sliderInstance.slider.destroy();
      }
      if (this.onBlockSelect) {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    initSlider() {
      const sliderOptions = {
        modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination],
        slidesPerView: 1,
        spaceBetween: 16,
        loop: false,
        watchOverflow: true,
        threshold: 2,
        navigation: {
          nextEl: this.section.querySelector('.reviews-showcase__next'),
          prevEl: this.section.querySelector('.reviews-showcase__prev'),
        },
        pagination: {
          el: this.querySelector('.reviews-showcase__pagination'),
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
        },
      };

      this.sliderInstance = new FoxTheme.Carousel(this, sliderOptions);
      this.sliderInstance.init();

      if (Shopify.designMode) {
        this.onBlockSelect = (event) => {
          if (event.detail.sectionId !== this.sectionId) return;
          const index = Number(event.target.dataset.index);
          if (!Number.isNaN(index)) this.sliderInstance.slider.slideTo(index);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }
  }

  customElements.define('reviews-showcase', ReviewsShowcase);
}
